import './PriceBadge.css'

export interface PriceBadgeProps {
  label?: string
  amount: string
}

export function PriceBadge({ label, amount }: PriceBadgeProps) {
  return (
    <span className="azoya-price-badge">
      {label && <span>{label}</span>}
      <span className="azoya-price-badge-amount">{amount}</span>
    </span>
  )
}
